import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { MeetingRoomRent } from "@/api/meetingRooms";
import { normalizeDatetime } from "@/utils";

interface EditMeetingRoomRentForm {
  rent_from: string;
  rent_to: string;
}

const editMeetingRoomRentFields: InputField[] = [
  {
    label: "Начало",
    name: "rent_from",
    placeholder: "1",
    type: "datetime-local",
    isRequired: true,
  },
  {
    label: "Конец",
    name: "rent_to",
    placeholder: "1",
    type: "datetime-local",
    isRequired: true,
  },
];

export function EditMeetingRoomRentModal({
  disclosure,
  rent,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  rent: MeetingRoomRent | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: EditMeetingRoomRentForm) => {
    return new Promise<Boolean>(async (resolve, _reject) => {
      api.meetingRooms
        .updateRent(rent?.id || 0, {
          ...rent,
          rent_from: data.rent_from,
          rent_to: data.rent_to,
        })
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<Boolean>(async (resolve, _reject) => {
      api.meetingRooms
        .deleteRent(rent?.id || 0)
        .then((_data) => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование брони"
      fields={editMeetingRoomRentFields}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        rent_from: normalizeDatetime(rent?.rent_from),
        rent_to: normalizeDatetime(rent?.rent_to),
      }}
    />
  );
}
